import React from 'react';
import NfcTagWriter from '../components/Nfc/NFCWriter';
import NfcTagTable from '../components/Nfc/NfcTagTable';
import Tabs from '../components/UI/Tabs';
import { useUser } from '../context/UserContext';

const NfcManagement = () => {
	const { hasAnyPermission, hasPermission } = useUser();

	const canWrite = hasPermission("nfc", "write");
	const canManage = hasAnyPermission("nfc", ["edit", "delete", "view"]);

	const tabs = [];

	if (!canWrite && !canManage) {
		return <div className="text-center text-red-500 text-2xl font-bold">У вас нет доступа к этому модулю</div>;
	}

	if (canWrite) {
		tabs.push({
			label: 'Создание меток',
			content: <NfcTagWriter />
		});
	}

	if (canManage) {
		tabs.push({
			label: 'Управление метками',
			content: <NfcTagTable />
		});
	}

	return (
		<div className="p-6">
			<Tabs tabs={tabs} />
		</div>
	);
};

export default NfcManagement;
